import { CouchResponse, PollOption, PollResponse, PollResponseCount, Post } from 'model';
import { BaseApi } from './BaseAPI';

export const baseURL = 'pollResponse/';

const PollResponseApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		// Get all of the responses for a given poll
		getPollResponses: builder.query<PollResponse[], Post['_id']>({
			query: poll => ({
				url: `${baseURL}${poll}/responses`
			}),
			providesTags: (_result, _error, arg) => {
				return [{ type: 'Poll Response', id: arg }];
			}
		}),
		// Get all of the response count for a given poll
		getPollResponseCount: builder.query<PollResponseCount, Post['_id']>({
			query: poll => ({
				url: `${baseURL}${poll}/count`
			}),
			providesTags: (_result, _error, arg) => {
				return [{ type: 'Poll Response', id: arg }];
			}
		}),
		// Get the current user's response to a given poll
		getUserPollResponse: builder.query<PollResponse, Post['_id']>({
			query: poll => ({
				url: `${baseURL}${poll}`
			}),
			providesTags: (_result, _error, arg) => [
				{ type: 'Poll Response', id: arg },
				{ type: 'Post', id: arg }
			]
		}),
		// Create the current user's reponse to a given poll
		createPollResponse: builder.mutation<PollResponse, { poll: Post['_id']; option: PollOption }>({
			query: ({ poll, option }) => ({
				url: `${baseURL}${poll}`,
				method: 'POST',
				body: option
			}),
			invalidatesTags: (_res, _error, input) => [
				{ type: 'Post', id: input.poll },
				{ type: 'Poll Response', id: input.poll }
			]
		}),
		// Update the current user's reponse to a given poll
		updatePollResponse: builder.mutation<PollResponse, { poll: Post['_id']; option: PollOption }>({
			query: ({ poll, option }) => ({
				url: `${baseURL}${poll}`,
				method: 'PUT',
				body: option
			}),
			invalidatesTags: (_res, _error, input) => [
				{ type: 'Post', id: input.poll },
				{ type: 'Poll Response', id: input.poll }
			]
		}),
		// Delete the current user's response to a poll
		deletePollResponse: builder.mutation<CouchResponse, Post['_id']>({
			query: (id: Post['_id']) => ({
				url: `${baseURL}${id}`,
				method: 'DELETE'
			}),
			invalidatesTags: (res, _error, input) => [{ type: 'Poll Response', id: input }]
		})
	})
});

export const {
	useGetPollResponsesQuery,
	useGetUserPollResponseQuery,
	useGetPollResponseCountQuery,
	useCreatePollResponseMutation,
	useUpdatePollResponseMutation,
	useDeletePollResponseMutation
} = PollResponseApi;
